{
  "oneOf": {
    "J5StateV1Cause": {
      "command": "Command",
      "externalEvent": "External Event",
      "init": "Init",
      "message": "Message",
      "psmEvent": "PSM Event"
    }
  }
}